import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FORCE_BACK_TO_CURRENT_LOCATION: InjectionToken<boolean> = new InjectionToken<boolean>(
  'forceBackToCurrentLocation',
  {
    factory: () => false
  }
);
